var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 355,
    viewBox: "0 0 436 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.557 33.68C300.099 33.68 373.497 26.1405 373.497 16.84C373.497 7.53953 300.099 0 209.557 0C119.016 0 45.6172 7.53953 45.6172 16.84C45.6172 26.1405 119.016 33.68 209.557 33.68Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.527 97.2433L328.897 36.3633C328.457 36.4133 328.027 36.4633 327.587 36.5033C304.117 38.9833 274.897 40.6333 243.117 41.3133L299.537 97.2333L299.527 97.2433Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.058 99.9748L227.758 41.5748C221.748 41.6448 215.678 41.6748 209.558 41.6748C182.488 41.6748 156.398 40.9948 133.008 39.7148L165.058 99.9648V99.9748Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.825 80.3622L376.545 25.7422C374.055 27.6622 369.885 29.3022 363.715 30.8422C357.865 32.3022 350.325 33.6522 341.195 34.8922L393.825 80.3622Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M394.399 90.102L335.349 39.082L305.359 101.252C337.849 98.822 368.009 95.072 394.399 90.102Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.838 103.182L126.258 41.9219L56.0781 93.2819C86.8181 98.1219 121.718 101.482 158.838 103.182Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.656 43.7852L171.336 103.685C185.966 104.205 200.896 104.475 216.026 104.475C242.966 104.475 269.306 103.635 294.396 102.015L235.646 43.7852H235.656Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M385.188 29.8438L403.677 88.2837C405.117 87.9837 406.557 87.6837 407.967 87.3837C418.118 85.2037 427.387 82.8538 435.717 80.3738L385.188 29.8438Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6953 87.8027L118.615 38.8327C108.955 38.1627 99.8753 37.3927 91.5253 36.5127C78.8753 35.1727 68.4353 33.6527 60.3853 31.9727L51.6953 87.8027Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2469 29.6933C45.6769 27.9833 42.2769 26.1233 40.7169 23.8633L4.54688 72.0833L51.2469 29.6933Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3381 38.1523L3.57812 82.4223C9.94812 84.1523 16.7881 85.8023 24.0781 87.3823C30.4881 88.7623 37.1581 90.0623 44.0781 91.2823L52.3481 38.1523H52.3381Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.041 319.211L435.801 88.6914C427.111 91.2014 418.201 93.3614 409.651 95.2014C408.051 95.5414 406.441 95.8814 404.811 96.2214L253.031 319.221L253.041 319.211Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M294.883 110C269.623 111.63 243.123 112.47 216.033 112.47C199.943 112.47 184.063 112.17 168.523 111.59L216.443 354.38L294.893 110H294.883Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M206.944 342.441L161.324 111.301C122.044 109.591 85.1437 106.051 52.8438 100.871L206.944 342.451V342.441Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M302.394 109.491L226.594 345.631L395.054 98.1211C367.614 103.241 336.194 107.081 302.394 109.491Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.54 99.3022C36.22 98.0222 29.16 96.6522 22.4 95.1922C15.08 93.6122 7.49 91.8022 0 89.7422L195.53 337.552L43.54 99.3022Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/Branding.960517ae5abfdab7a5373924536fbbd2.svg";
export { ForwardRef as ReactComponent };